// ----------------------------------------------------------------------------
// Component: Sharpener Type Select
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import './_sharpener-type-select.scss';
